import React from "react";
import get from "lodash/get";

import CommonRow from "../common-row";
import CollectionHeading from "../../atoms/collection-heading";

const FourCollection12Stories1Ad = ({ collection }) => {
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const subCollections =
    collection.items && collection.items.length > 0 && collection.items.filter(item => item.type === "collection");

  if (!(subCollections && subCollections.length)) {
    return null;
  }

  return (
    <>
      {showCollectionName && <CollectionHeading collection={collection} />}
      {subCollections.slice(0, 4).map(item => (
        <CommonRow collection={item} />
      ))}
    </>
  );
};

export default FourCollection12Stories1Ad;
